"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvestmentOptionList = (function () {
    function InvestmentOptionList() {
        this._list = [];
    }
    InvestmentOptionList.prototype.addInvestmentOption = function (investmentOption) {
        this._list.push(investmentOption);
    };
    Object.defineProperty(InvestmentOptionList.prototype, "list", {
        get: function () { return this._list; },
        enumerable: true,
        configurable: true
    });
    InvestmentOptionList.prototype.getOptionAtPosition = function (position) {
        return this._list[position - 1];
    };
    Object.defineProperty(InvestmentOptionList.prototype, "numberOfInvestmentOptions", {
        get: function () {
            return this._list.length;
        },
        enumerable: true,
        configurable: true
    });
    return InvestmentOptionList;
}());
exports.InvestmentOptionList = InvestmentOptionList;
//# sourceMappingURL=InvestmentOptionList.js.map